export default Object.freeze({
  baseURL: 'https://dev.linguaprocenter.com:443/api/'
})
